<template>

    <div>
      <div class="reportView reportBoxBg top">
        <div class="reportViewHeader">
          <div class="reportViewLeft">报表预览区(已选表头展示)</div>
          <div class="reportViewRight">
            <el-button type="primary" plain size="medium" @click="showTable">预览表格</el-button>
            <el-button type="primary" size="medium" @click="reportList" ><i class="el-icon-arrow-left el-icon--left">上一步</i></el-button>
            <el-button type="primary" size="medium" @click="submitResult">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </div>
        </div>
        <div class="reportViewTable">
          <div class="reportViewDatas">
            <div class="reportViewData" v-for="item in renderData2" :key="id">{{item.label}}</div>
            <div class="reportViewData" v-for="item in renderData3" :key="id">{{item.label}}</div>
          </div>
        </div>
      </div>

      <el-row :gutter="10" class="reportSelect">
        <el-col :span="8">
          <div class="reportSelectLeft reportBoxBg">
            <div class="rsForm">
              <div class="df fb dfac"><p>选择数据集</p>:</div>
              <el-select placeholder="请选择" v-model="selectValue" @change="changeValue">
                <el-option
                  v-for="item1 in cusList"
                  :key="item1.id"
                  :label="item1.ds_name"
                  :value="item1.id">
                </el-option>
              </el-select>
            </div>
            <div class="rsForm">
              <div class="df fb dfac"><p>搜索</p>:</div>
              <el-input
                placeholder="输入字段名字搜索"
                v-model="filterText">
              </el-input>
            </div>
            <div class="treeBoxs">
              <div class="df fb dfac"><p>选择可以添加到报表的字段</p>:</div>
              <div class="df jsb treeBox">
                <div class="leftTree">
                  <el-tree
                    ref="tree"
                    class="filter-tree"
                    :data="data"
                    show-checkbox
                    default-expand-all
                    :filter-node-method="filterNode"
                    node-key="id"
                    highlight-current
                    :props="defaultProps"
                  />
                </div>
                <div class="rightBtn">
                  <el-button type="primary" @click="getCheckedNodes('data1',1,1)">报表筛选</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data2',2,2)">列标签</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data3',3,3)">数 值</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data4',4,4)">排序标签</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16" >
          <div  class="reportBoxBg reportSelectRight">
            <el-row :gutter="10">
              <el-col :span="12" class="mb20">
                <!--报表筛选-->
                <el-card class="box-card">
                  <div slot="header" class="df jsb">
                    <span >报表筛选</span>
                    <div >
                      <el-button  icon="el-icon-delete" @click="deleteItem('data1', 'tree1')" ></el-button>
                      <el-button icon="el-icon-sort"  @click="dialogVisible1 = true"></el-button>
                    </div>
                  </div>
                  <div >
                    <el-tree
                      ref="tree1"
                      check-strictly
                      :data="data1"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      highlight-current
                      :props="defaultProps"
                    >
                      <div class="custom-tree-node df jsb" slot-scope="{ node, data }"
                      >
                        <span >{{ node.label }}</span>
                        <el-button class="treeBtn" type="primary" round @click="editNode(data,1,1)" :data-id="data.id" :data="data" >编辑</el-button>
                      </div>
                    </el-tree>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="12"  class="mb20">
                <!--列标签-->
                <el-card class="box-card">
                  <div slot="header" class="df jsb">
                    <span >列标签</span>
                    <div >
                      <el-button  icon="el-icon-delete" @click="deleteItem('data2', 'tree2')" ></el-button>
                      <el-button icon="el-icon-sort"  @click="dialogVisible2 = true"></el-button>
                    </div>
                  </div>
                  <div >
                    <el-tree
                      ref="tree2"
                      check-strictly
                      :data="data2"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      highlight-current
                      :props="defaultProps"
                    >
                      <div class="custom-tree-node df jsb" slot-scope="{ node, data }"
                      >
                        <span >{{ node.label }}</span>
                        <el-button class="treeBtn" type="primary" round @click="editNode(data,2,2)" :data-id="data.id" :data="data" >编辑</el-button>
                      </div>
                    </el-tree>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="12">
                <!--数值-->
                <el-card class="box-card">
                  <div slot="header" class="df jsb">
                    <span >数值</span>
                    <div >
                      <el-button  icon="el-icon-delete" @click="deleteItem('data3', 'tree3')" ></el-button>
                      <el-button icon="el-icon-sort"  @click="dialogVisible3 = true"></el-button>
                    </div>
                  </div>
                  <div >
                    <el-tree
                      ref="tree3"
                      check-strictly
                      :data="data3"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      highlight-current
                      :props="defaultProps"
                    >
                      <div class="custom-tree-node df jsb" slot-scope="{ node, data }"
                      >
                        <span >{{ node.label }}</span>
                        <el-button class="treeBtn" type="primary" round @click="editNode(data,3,3)" :data-id="data.id" :data="data" >编辑</el-button>
                      </div>
                    </el-tree>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="12">
                <!--排序标签-->
                <el-card class="box-card">
                  <div slot="header" class="df jsb">
                    <span >排序标签</span>
                    <div >
                      <el-button  icon="el-icon-delete" @click="deleteItem('data4', 'tree4')" ></el-button>
                      <el-button icon="el-icon-sort"  @click="dialogVisible4 = true"></el-button>
                    </div>
                  </div>
                  <div >
                    <el-tree
                      ref="tree4"
                      check-strictly
                      :data="data4"
                      show-checkbox
                      default-expand-all
                      node-key="id"
                      highlight-current
                      :props="defaultProps"
                    >
                      <div class="custom-tree-node df jsb" slot-scope="{ node, data }"
                      >
                        <span >{{ node.label }}</span>
                        <el-button class="treeBtn" type="primary" round @click="editNode(data,4,4)" :data-id="data.id" :data="data" >编辑</el-button>
                      </div>
                    </el-tree>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>



      <!--报表筛选-->
      <el-dialog title="值字段设置：" :visible.sync="filterFormVisible">
        <el-form :model="form">
          <el-input type="hidden" v-model="form.id"></el-input>
          <el-form-item label="自定义名称：" :label-width="formLabelWidth">
            <el-input v-model="form.label" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieldEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="中英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieleChEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="初始化条件:" :label-width="formLabelWidth">
            <div>

            </div>
            <div>
              <div style="float: left">
                <el-select v-model="form.conditionName" placeholder="请选择活动区域" >
                  <el-option label="无" value="isempty"></el-option>
                  <el-option label="大于等于" value=">="></el-option>
                  <el-option label="小于等于" value="<="></el-option>
                  <el-option label="等于" value="="></el-option>
                  <el-option label="不等于" value="!="></el-option>
                  <el-option label="大于" value=">"></el-option>
                  <el-option label="小于" value="<"></el-option>
                  <el-option label="区间" value="between" ></el-option>
                  <el-option label="为空" value="isnull"></el-option>
                  <el-option label="不为空" value="isnotnull"></el-option>
                </el-select>
              </div>
              <div style="float: left;margin-left: 40px">
                <el-form-item  prop="conditionValue" :rules="[{ type: 'number', message: '必须为数字值'}]" style="width: 100px">
                  <el-input type="conditionValue" v-model.number="form.conditionValue" autocomplete="off"></el-input>
                </el-form-item>
              </div>
              <div style="float: left;margin-left: 10px">
                <el-form-item  prop="conditionValue" :rules="[{ type: 'number', message: '必须为数字值'}]" style="width: 100px">
                  <el-input type="conditionValue" v-model.number="form.conditionValue2" autocomplete="off" placeholder="仅供区间使用"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="savediaForm(1)" >确 定</el-button>
        </div>
      </el-dialog>

      <!--弹出列标签表单-->
      <el-dialog title="值字段设置：" :visible.sync="cloumnFormVisible">
        <el-form :model="form">
          <el-input v-model="form.colType" value="columnF" type="hidden"></el-input>
          <el-form-item label="自定义名称：" :label-width="formLabelWidth">
            <el-input v-model="form.label" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieldEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="中英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieleChEnName" autocomplete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="savediaForm(2)" >确 定</el-button>
        </div>
      </el-dialog>

      <!--弹出数值表单-->
      <el-dialog title="值字段设置：" :visible.sync="numberValueFormVisible">
        <el-form :model="form">
          <el-input v-model="form.colType" value="valueF" type="hidden"></el-input>
          <el-form-item label="自定义名称：" :label-width="formLabelWidth">
            <el-input v-model="form.label" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieldEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="中英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieleChEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="汇总方式:" :label-width="formLabelWidth">
            <el-select v-model="form.condition" placeholder="请选择活动区域"   >
              <el-option label="计数" value="count" selected="selected" ></el-option>
              <el-option label="求和" value="sum"></el-option>
              <el-option label="平均值" value="avg"></el-option>
              <el-option label="去重计数" value="countdistinct"></el-option>
              <el-option label="去重求和" value="sumdistinct"></el-option>
              <el-option label="最大值" value="max"></el-option>
              <el-option label="最小值" value="min"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="savediaForm(3)" >确 定</el-button>
        </div>
      </el-dialog>

      <!--弹出排序标签表单-->
      <el-dialog title="值字段设置：" :visible.sync="sortFormVisible">
        <el-form :model="form">
          <!--                  <el-form-item >-->
          <!--                    <el-input v-model="form.label" value="sortF" type="hidden"></el-input>-->
          <!--                  </el-form-item>-->
          <el-form-item label="自定义名称：" :label-width="formLabelWidth">
            <el-input v-model="form.label" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieldEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="中英文名称：" :label-width="formLabelWidth">
            <el-input v-model="form.fieleChEnName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序标签:" :label-width="formLabelWidth">
            <el-select v-model="form.conditionName" placeholder="请选择活动区域">
              <el-option label="升序" value="asc" ></el-option>
              <el-option label="降序" value="desc"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="savediaForm(4)" >确 定</el-button>
        </div>
      </el-dialog>



      <!--排序弹窗
      这个框-->
      <el-dialog
        title="排序"
        :visible.sync="dialogVisible1"
        width="45%"
        :before-close="handleClose">
        <div v-for="(item,index) in renderData1" >
          <div>
            <div class="dialog-div">
                    <span>
                      {{index+1}}.
                    {{item.label}}
                  </span>
              <div class="dialog-btn">
                <div>挪动至第 <el-input v-model="item.target"/>
                  <span >条</span>
                  <el-button @click="go1(item,index)" type="primary" round >Go</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible1 = false">取 消</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data1',1,1)" >确 定</el-button>
                </span>
      </el-dialog>

      <!--排序弹窗
     这个框-->
      <el-dialog
        title="排序"
        :visible.sync="dialogVisible2"
        width="45%"
        :before-close="handleClose">
        <div v-for="(item,index) in renderData2" >
          <div>
            <div class="dialog-div">
                    <span>
                      {{index+1}}.
                    {{item.label}}
                  </span>
              <div class="dialog-btn">
                <div>挪动至第  <el-input v-model="item.target"/>
                  <span >条</span>
                  <el-button @click="go2(item,index)" type="primary" round >Go</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible2 = false">取 消</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data2',2,2)">确 定</el-button>
                </span>
      </el-dialog>

      <!--排序弹窗
     这个框-->
      <el-dialog
        title="排序"
        :visible.sync="dialogVisible3"
        width="45%"
        :before-close="handleClose">
        <div v-for="(item,index) in renderData3" >
          <div>
            <div class="dialog-div">
                    <span>
                      {{index+1}}.
                    {{item.label}}
                  </span>
              <div class="dialog-btn">
                <div>挪动至第  <el-input v-model="item.target"/>
                  <span >条</span>
                  <el-button @click="go3(item,index)" type="primary" round >Go</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible3 = false">取 消</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data3',3,3)">确 定</el-button>
                </span>
      </el-dialog>

      <!--排序弹窗
     这个框-->
      <el-dialog
        title="排序"
        :visible.sync="dialogVisible4"
        width="45%"
        :before-close="handleClose">
        <div v-for="(item,index) in renderData4" >
          <div>
            <div class="dialog-div">
                    <span>
                      {{index+1}}.
                    {{item.label}}
                  </span>
              <div class="dialog-btn">
                <div>挪动至第  <el-input v-model="item.target"/>
                  <span >条</span>
                  <el-button @click="go4(item,index)" type="primary" round >Go</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible4 = false">取 消</el-button>
                  <el-button type="primary" @click="getCheckedNodes('data4',4,4)">确 定</el-button>
                </span>
      </el-dialog>

      <!--预览弹框-->
      <el-drawer
        title="预览"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="500px">
        <div v-html="showTableData">
        </div>
      </el-drawer>


    </div>

</template>

<script>
import customQueryEdit from "./customQueryEdit";

export default {
  data() {
    return {


      treeForm:{},
      cusList:[],
      filterText: '',
      renderData: [],
      renderData1: [],
      renderData2: [],
      renderData3: [],
      renderData4: [],
      selectValue: '',

      //预览弹窗
      drawer: false,
      direction: 'ttb',
      showTableData:'',


      //下拉列表相关
      obj:{
        count:'计数',
        sum:'求和',
        avg:'平均值',
        countdistinct:'去重计数',
        sumdistinct:'去重求和',
        max:'最大值',
        min:'最小值'
      },


      //树相关
      showEdit: false,
      showSort:false,
      checkAll: false,
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      result: [], // 最后要提交的值,
      data:[

      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },

      //报表筛选弹出表单
      filterFormVisible: false,
      //列标签弹出表单
      cloumnFormVisible: false,
      //数值弹出表单
      numberValueFormVisible: false,
      //排序标签弹出表单
      sortFormVisible: false,
      form:{
        condition:'count',
        conditionName:'',
        conditionValue:'',
        conditionValue2:'',
        label1:''
      },
      // form: {
      //   detailOrder:0,
      //   label:'',
      //   colType:1,
      //   colName:'',
      //   colEnName:'',
      //   colChEnName:''
      // },
      formLabelWidth: '120px',

      //点击排序弹框,默认不展示
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      sessionData:[]
    }

  },
  //使用过滤器给展示的英文赋值
  filters: {
    getcondition(condition) {
      switch (condition) {
        case 'count':
          return '计数';
        case 'sum':
          return '求和';
        case 'avg':
          return '平均值';
        case 'countdistinct':
          return '去重计数';
        case 'sumdistinct':
          return '去重求和';
        case 'max':
          return '最大值';
        case 'min':
          return '最小值';
        default:
          return '';
      }
    },
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {//挂载函数,挂载后执行
    // sessionStorage.setItem("sessionStorage",JSON.stringify(sessionStorage))
    // let session = sessionStorage.getItem(JSON.stringify(sessionStorage))
    // console.log(session)
    // let type1 = sessionStorage.getItem("this[type]1")
    // let checkNodes = JSON.stringify(type1)
    // console.log("初始化时checkNodes是",checkNodes)

    if(this.$route.params.renderData1 == null){

    }else if(this.$route.params.renderData1 == ""){

    }else {
      this.renderData1 = this.$route.params.renderData1
      this.renderData2 = this.$route.params.renderData2
      this.renderData3 = this.$route.params.renderData3
      this.renderData4 = this.$route.params.renderData4

      this.data1 = this.$route.params.renderData1
      this.data2 = this.$route.params.renderData2
      this.data3 = this.$route.params.renderData3
      this.data4 = this.$route.params.renderData4

      let optionValue = sessionStorage.getItem("optionValue")
      this.selectValue = optionValue

      console.log("optionValue",optionValue)
    }



    this.getDataFromApi()
    let cusId=this.$route.params.cusId
    sessionStorage.setItem("cusId",cusId)

    console.log("上个页面传来的是",this.$route)
    // let targetObj = sessionStorage.getItem("targetObj")
    // let targetObj = JSON.stringify(targetObjArr)

    // let ds_type = this.$route.params.targetObj.ds_type
    // let id  = this.$route.params.targetObj.id

    let ds_type = sessionStorage.getItem("ds_type")
    let id = sessionStorage.getItem("id")
    this.fetchTreeData(ds_type,id)

    let dataSetId = sessionStorage.getItem("dataSetId")
    this.changeValue(dataSetId)

    let list = sessionStorage.getItem("formatData")
    this.formatData(list)



  }
  ,
  methods: {
    // //点击全选
    // handleCheckAllChange(val) {
    //   if (this.checkAll) {
    //     this.$refs.tree.setCheckedNodes(this.data);
    //   } else {
    //     this.$refs.tree.setCheckedKeys(this.data);
    //   }
    // },
    //点击预览弹出弹框
    showTable(){
      this.$http.post('/reporttools/sys-dataset/queryTable',sessionStorage).then(resp =>{
        this.showTableData = resp.data
        console.log("this.showTableData",this.showTableData)
      })
      this.drawer = true;

    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    //点击跳转
    go1(item, index){
      const target = item.target
      const array1 = this.renderData1[target - 1]
      if (target > this.renderData1.length){
        this.$message.error("请确认您输入的条数是否正确")
        return
      }
      this.$set(this.renderData1, target - 1, item)
      this.$set(this.renderData1, index, array1)
      //this.$set(this[type],index,array1)
    },


    //点击跳转
    go2(item, index){
      const target = item.target
      const array1 = this.renderData2[target - 1]
      if (target > this.renderData2.length){
        this.$message.error("请确认您输入的条数是否正确")
        return
      }
      this.$set(this.renderData2, target - 1, item)
      this.$set(this.renderData2, index, array1)
    },



    //点击跳转
    go3(item, index){
      const target = item.target
      const array1 = this.renderData3[target - 1]
      if (target > this.renderData3.length){
        this.$message.error("请确认您输入的条数是否正确")
        return
      }
      this.$set(this.renderData3, target - 1, item)
      this.$set(this.renderData3, index, array1)
    },

    //点击跳转
    go4(item, index){
      const target = item.target
      const array1 = this.renderData4[target - 1]
      if (target > this.renderData4.length){
        this.$message.error("请确认您输入的条数是否正确")
        return
      }
      this.$set(this.renderData4, target - 1, item)
      this.$set(this.renderData4, index, array1)
    },
    deleteItem(data, tree) {
      console.log("删除的是",data, tree)
      const checkTreeNodes = this.$refs[tree].getCheckedNodes()
      const targetData = this[data]
      console.log("checkTreeNodes",checkTreeNodes)
      console.log("targetData",targetData)
      checkTreeNodes.forEach((item, index) => {
        targetData.forEach((it, idx) => {
          if (it.id === item.id) {
            targetData.splice(idx, 1)
          }
        })
      })
      console.log(checkTreeNodes, targetData)
    },
    showinput(value){
      const targetObj = this.cusList.find((item => item.id === value))
      console.log("成功",targetObj)
    },
    //报表赋值
    chuanzhi(node){
      this.form.label=node.label
    },


    /**
     * 报表筛选
     * children: null
     dbSourceId: null
     detailId: "1003"
     dsId: null
     fieldEnName: "cusName"
     fieleChEnName: "机构名称cusName"
     id: "B001005"
     label: "机构名称"
     */
    getCheckedNodes(type,screen,top) {

      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false

     // let checkNodesForm = sessionStorage.getItem("checkNodesForm")
     //
     //  console.log("checkNodesForm",checkNodesForm)


      const deleteNodes =  this.$refs.tree.getCheckedNodes()
      console.log("this.$refs.tree.getCheckedNodes()",this.$refs.tree.getCheckedNodes())
      console.log("deleteNodes里有",deleteNodes)


      // let treeForm = this.treeForm
      //
      // console.log("treeForm",treeForm)
      //
      // deleteNodes.splice(0,1)
      //
      for (let i=0;i<deleteNodes.length;i++){
        if(deleteNodes[i].children == null){

        }else {
          deleteNodes.splice(0,1)
        }

      }

      // if(deleteNodes[i]-1<deleteNodes.length){
      //   console.log("deleteNodes.length",deleteNodes.length)
      //   alert("i小于")
      // }else if(i=deleteNodes.length){
      //   alert("i等于")
      //   console.log("deleteNodes.length",deleteNodes.length)
      // }else if(i>deleteNodes.length){
      //   alert("i大于")
      //   console.log("deleteNodes.length",deleteNodes.length)
      // }


      // for (let i=0;i<deleteNodes.length;i++){
      //
      // }


      // const targetData = this.data
      // deleteNodes.forEach((item, index) => {
      //   targetData.forEach((it, idx) => {
      //     if (it.id === item.id) {
      //       targetData.splice(idx, 0)
      //     }
      //   })
      // })

      // sessionStorage.getItem("checkNodes")
      console.log("deleteNodes里面有",deleteNodes)
      if(deleteNodes[0].condition == undefined){
        const checkNodes = deleteNodes

        //开始判断顶部的展示
        if (top==1){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                colType:'1',
                //detailOrder:index
                detailOrder:"1"
              })
              console.log("this[type]",this[type])
              console.log("==========下标",checkNodes.indexOf(item));
            }
          })
          this.renderData1 = this[type]
        }
        if (top==2){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                colType:'2',
                //detailOrder:index
                detailOrder:"2"
              })
            }
          })
          this.renderData2 = this[type]
        }
        if (top==3){

          // item.condition = "count"
          checkNodes.forEach(item => {

            // console.log("renderData3",this.renderData3)
            // for (let i=0;i<this[type].length;i++){
            //   console.log("checkNodes.condition",this[type][i])
            //   if(this[type][i].condition === 'undefined'){
            //     item.condition = "count"
            //   }else {
            //     item.condition = this[type][i].condition
            //   }
            //
            //   console.log("checkNodes.condition",this[type][i])
            // }
            //


            // console.log("checkNodes.condition",item.condition1)
            // if(checkNodes.condition1 == null){
            //   alert("checkNodes.condition1为空")
            //   if(checkNodes.condition1 == null){
            //     item.condition1 = "_计数"
            //   }else {

            //   }
            //   this[type].condition1 = item.condition1
            // }else {
            //   alert("checkNodes.condition1不为空")
            // }
            //
            // console.log("this[type]的值是",this[type])

                let formCondition = sessionStorage.getItem("formCondition")

                if (formCondition == null){
                  item.condition1 = "_计数"
                }else {
                  item.condition1 = formCondition
                }

            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label+item.condition1,
                label1: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                condition:'count',
                condition1:'_计数',
                colType:'3',
                //detailOrder:index
                detailOrder:"3"
              })
            }
          })

          this.renderData3 = this[type]
        }
        if (top==4){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                condition:'asc',
                colType:'4',
                //detailOrder:index
                detailOrder:"4"
              })
            }
          })
          this.renderData4 = this[type]
        }
        this.renderData = this[type]//向this.renderData中赋值,所以放在上面
      }else {

        const checkNodes = this.checkNodesForm

        //开始判断顶部的展示
        if (top==1){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                colType:'1',
                //detailOrder:index
                detailOrder:"1"
              })
              console.log("this[type]",this[type])
            }
          })
          this.renderData1 = this[type]
        }
        if (top==2){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                colType:'2',
                //detailOrder:index
                detailOrder:"2"
              })
            }
          })
          this.renderData2 = this[type]
        }
        if (top==3){

          // item.condition = "count"
          checkNodes.forEach(item => {

            // console.log("renderData3",this.renderData3)
            // for (let i=0;i<this[type].length;i++){
            //   console.log("checkNodes.condition",this[type][i])
            //   if(this[type][i].condition === 'undefined'){
            //     item.condition = "count"
            //   }else {
            //     item.condition = this[type][i].condition
            //   }
            //
            //   console.log("checkNodes.condition",this[type][i])
            // }

            console.log("checkNodes.condition",item.condition1)
            if(checkNodes.condition1 == null){
              //alert("checkNodes.condition1为空")
              if(checkNodes.condition1 == null){
                item.condition1 = "_计数"
              }else {
                item.condition1 = checkNodes.condition1
              }
              this[type].condition1 = item.condition1
            }else {
            }

            console.log("this[type]的值是",this[type])
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label+item.condition1,
                label1: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                condition:'count',
                condition1:'_计数',
                colType:'3',
                //detailOrder:index
                detailOrder:"3"
              })
            }
          })

          this.renderData3 = this[type]
        }
        if (top==4){
          checkNodes.forEach(item => {
            let index = checkNodes.indexOf(item)+1
            if (!this[type].find(it => it.id === item.id)) {
              this[type].push({
                index:index,
                id: item.id,
                label: item.label,
                children: item.children,
                dbSourceId:item.dbSourceId,
                detailId: item.detailId,
                dsId: item.dsId,
                fieldEnName: item.fieldEnName,
                fieleChEnName: item.fieleChEnName,
                condition:'asc',
                colType:'4',
                //detailOrder:index
                detailOrder:"4"
              })
            }
          })
          this.renderData4 = this[type]
        }
        this.renderData = this[type]//向this.renderData中赋值,所以放在上面
      }


      // sessionStorage.setItem("checkNodes",JSON.stringify(checkNodes))
      // console.log("checkNodes现在是",checkNodes)



      console.log("this.$refs.tree.getCheckedNodes()",this.$refs.tree.getCheckedNodes())

      //  这是公共的
      // checkNodes.forEach(item => {
      //   if (!this[type].find(it => it.id === item.id)) {
      //     this[type].push({
      //       id: item.id,
      //       label: item.label,
      //       children: item.children,
      //       dbSourceId:item.dbSourceId,
      //       detailId: item.detailId,
      //       dsId: item.dsId,
      //       fieldEnName: item.fieldEnName,
      //       fieleChEnName: item.fieleChEnName,
      //     })
      //   }
      // })



      // let obj = {};
      // obj.name = this.renderData[0].id+screen;
      // obj.data = this.renderData;
      // this.sessionData[screen] = obj;
      // sessionStorage.setItem("sessionData",JSON.stringify(this.sessionData))


      // //  let obj = {};
      // obj.name = this.renderData[0].id+screen;
      // obj.data = this.renderData;
      // this.sessionData[screen].push(obj);

      //测试调用增加方法
      // if(type == 1){
      //   this.savediaForm("1")
      // }
      // if(type == 2){
      //   this.savediaForm("2")
      // }
      // if(type == 3){
      //   this.savediaForm("3")
      // }
      // if(type == 4){
      //   this.savediaForm("4")
      // }

      //放开就可以存
      if(screen == 1){

        for (let i=0;i<this.renderData.length;i++){
          sessionStorage.setItem(this.renderData[i].id+screen,JSON.stringify(this.renderData[i]))
          console.log("this.renderData的值是",this.renderData[i].id)
        }
        console.log("报表筛选按钮增加进的数据",((sessionStorage)))
      }
      if (screen == 2){
        for (let i=0;i<this.renderData.length;i++){
          sessionStorage.setItem(this.renderData[i].id+screen,JSON.stringify(this.renderData[i]))
          console.log("this.renderData的值是",this.renderData[i].id)
        }
        console.log("报表筛选按钮增加进的数据",((sessionStorage)))
      }
      if(screen == 3){
        for (let i=0;i<this.renderData.length;i++){
          sessionStorage.setItem(this.renderData[i].id+screen,JSON.stringify(this.renderData[i]))
          console.log("this.renderData的值是",this.renderData[i].id)
        }
        console.log("报表筛选按钮增加进的数据",((sessionStorage)))
      }
      if (screen == 4){
        for (let i=0;i<this.renderData.length;i++){
          sessionStorage.setItem(this.renderData[i].id+screen,JSON.stringify(this.renderData[i]))
          console.log("this.renderData的值是",this.renderData[i].id)
        }
        console.log("报表筛选按钮增加进的数据",((sessionStorage)))
      }
      console.log("点击完左边按钮之后当前页面存的数据有",((sessionStorage)))

      this.form.colType = screen


      console.log("存的值",this.$refs.tree.getCheckedNodes());
      console.log("id加screen的值",this.renderData[0].id+screen);
      console.log("this[type]",this[type])
    },






    //监控搜索的值
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //初始查询select
    getDataFromApi() {
      this.$http.get("/reporttools/sys-dataset/query").then(resp => {

        console.log("resp.data",resp.data)

        this.cusList = resp.data;//设置当前页数据
        console.log("this.selectValue",this.selectValue)
          const selectObj = this.cusList.find((res) => res.id === this.selectValue)
          this.fetchTreeData(selectObj.ds_type,selectObj.id)
          console.log("是不是datasetId",selectObj.id)
          console.log(this.cusList)


        console.log("页面传来的",cusId)
        console.log("上个页面传来的id被存进去了",sessionStorage)
          console.log(sessionStorage)//打印sessionStorage是否被清除

        }

      )
    },
    //点击编辑弹出框并回显数据
    editNode(data,type,order){

      this.form=data
      console.log(data)

      if(type == 1,order== 1){
        this.filterFormVisible  = true
      }
      if (type == 2,order== 2){
        this.cloumnFormVisible  = true
      }
      if (type == 3,order== 3){
        this.numberValueFormVisible  = true
      }
      if (type == 4,order== 4){
        this.sortFormVisible  = true
      }
      this.form.colType = type
     // this.form.detailOrder = order
    },

    formatData(list) {
      console.log("list里面有",list)
      list.forEach(item => {
        if(item.list) {
          this.formatData(item.list)
        }
        console.log("formatData里的是",item)
        item.label = item.name
        item.children = item.list

        delete item.list
        delete item.name
      })
    },
    /** 获取树信息 */
    fetchTreeData(ds_type,id) {
      console.log("调用fetchTreeData接口了",ds_type,id)
      // 下面可以掉接口了
      console.log("点击左上角切换时",ds_type,id)
      this.$http.get("/reporttools/sys-dataset/querytree/"+ds_type+"/"+id).then(resp => {
        console.log("this.formatData",this.formatData)
        this.formatData(resp.data)
        this.treeForm = resp.data
        let list = resp.data
        sessionStorage.setItem("formatData",JSON.stringify(list))
        this.data = resp.data;
        console.log("点击option查询的信息",resp.data)
      })
    },

    // /** 获取树信息 */
    // fetchTreeData(id) {
    //   // 下面可以掉接口了
    //   this.$http.get("reporttools/sys-dataset/querytree/"+id).then(resp => {
    //     this.formatData(resp.data)
    //     this.data = resp.data;
    //     console.log(11,resp.data)
    //   })
    // },
    //点击option进行选择
    changeValue(value){
      sessionStorage.setItem("optionValue",value)
      console.log("点击changeValue的值",value)
      console.log("点击this.cusList",this.cusList)
      console.log("点击option时",this.selectValue)
      // sessionStorage.setItem("cusList",JSON.stringify(this.cusList))

      // console.log(sessionStorage.getItem("cusList"))

      const targetObj = this.cusList.find((item => item.id === value))
      console.log("targetObj是",targetObj)
      sessionStorage.setItem("id",targetObj.id)
      sessionStorage.setItem("ds_type",targetObj.ds_type)

      const {ds_type, id} = targetObj
      this.fetchTreeData(ds_type,id)
      sessionStorage.setItem("dataSetId",id)
      sessionStorage.setItem("targetObj",JSON.stringify(targetObj))
      console.log("点击切换出来的this.cusList",targetObj)
      console.log("点击切换产生的值",sessionStorage)
    },


    //点击增加数值弹框表单
    // saveNumber(type){
    // this.numberValueFormVisible=false
    //   if(type="number"){
    //     sessionStorage.setItem(this.form.id+type,JSON.stringify(this.form))
    //   }
    //   console.log(77,((sessionStorage)))
    // },

    //点击取消
    cancelForm(){
      this.filterFormVisible=false
      this.sortFormVisible=false
      this.numberValueFormVisible=false
      this.cloumnFormVisible=false
    },
    //点击增加
    savediaForm(type){
      this.filterFormVisible=false
      this.sortFormVisible=false
      this.numberValueFormVisible=false
      this.cloumnFormVisible=false

      // let obj = {};
      // obj.name = this.renderData[0].id+type;
      // obj.data = this.renderData;
      // this.sessionData[type] = obj;
      // sessionStorage.setItem("sessionData",JSON.stringify(this.sessionData))

      if(type == 1){
        sessionStorage.setItem(this.form.id+type,JSON.stringify(this.form))
        console.log("点击报表筛选表单增加进的数据",((sessionStorage)))
      }
      if (type == 2){
        sessionStorage.setItem(this.form.id+type,JSON.stringify(this.form))
        console.log("点击列标签表单增加进的数据",((sessionStorage)))
      }
      if(type == 3){
        // alert("触发了方法")

        // let label = this.form.label.split('_')
        //
        // console.log("点击this.form",label)
        // // this.form.condition = this.$refs.tree.getCheckedNodes()
        // //this.
        // console.log("this.form",this.form)
        // if(this.form.condition == "count"){
        //   let formCondition = "_计数"
        //   this.form.label = this.form.label1+"_计数"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "sum"){
        //   let formCondition = "_求和"
        //   this.form.label = this.form.label1+"_求和"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "avg"){
        //   let formCondition = "_平均值"
        //   this.form.label = this.form.label1+"_平均值"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "countdistinct"){
        //   // let formCondition = "_去重计数"
        //   // this.form.label = this.form.label1+"_去重计数"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "sumdistinct"){
        //   // let formCondition = "_去重求和"
        //   // this.form.label = this.form.label1+"_去重求和"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "max"){
        //   // let formCondition = "_最大值"
        //   // this.form.label = this.form.label1+"_最大值"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        // if(this.form.condition == "min"){
        //   // let formCondition = "_最小值"
        //   // this.form.label = this.form.label1+"_最小值"
        //   sessionStorage.setItem("formCondition",formCondition)
        // }
        //
        // //sessionStorage.setItem("formCondition",this.form.condition)
        //
        // //console.log("checkNodesForm",checkNodesForm)
        // console.log("点击赋值后",this.checkNodesForm)
        // let checkNodesForm = this.form
        // console.log("checkNodesForm",checkNodesForm)


        // this.deleteItem("data3 ","tree3")
        // this.getCheckedNodes("data3","3","3")

        sessionStorage.setItem(this.form.id+type,JSON.stringify(this.form))
        console.log("点击数值表单this.form",this.form)

        // this.data3.form.push({
        //   label: this.form.label+this.form.condition,
        //   condition:this.form.condition,
        // })


          //     this[type].push({
          //       id: item.id,
          //       label: item.label,
          //       children: item.children,
          //       dbSourceId:item.dbSourceId,
          //       detailId: item.detailId,
          //       dsId: item.dsId,
          //       fieldEnName: item.fieldEnName,
          //       fieleChEnName: item.fieleChEnName,
          //       colType:'1',
          //       detailOrder:'1'
          //     })
          //
          // this.renderData1 = this[type]


      }
      if (type == 4){

        sessionStorage.setItem(this.form.id+type,JSON.stringify(this.form))
        console.log("点击排序表单增加进的数据",((sessionStorage)))
      }
      console.log("此时当前页面存的数据有",((sessionStorage)))


      this.form={
        colName:'',
        colEnName:'',
        colChEnName:''
      }
      this.form.colType = type
    },


    // submitResult(){
    //   this.
    //   this.$http.post("reporttools/report-show/addReportShow",this.result).then(
    //     resp=>{
    //       console.log(resp)
    //     })
    // },
    //点击下一步
    submitResult(){

      console.log("点击下一步打印this.renderData1",this.renderData1)
      console.log("点击下一步打印this.renderData2",this.renderData2)
      console.log("点击下一步打印this.renderData3",this.renderData3)
      console.log("点击下一步打印this.renderData4",this.renderData4)
      //获取增加页面的最后一个form表单存储的数据
      // sessionStorage.submit = this.sessionStorage.lastform;

      let dataSetId  = sessionStorage.getItem("dataSetId")
      console.log(dataSetId)
      // sessionStorage.setItem("customQuery"+dataSetId,JSON.stringify(sessionStorage))
      console.log("点击下一步时session里有",sessionStorage)
      // let targetObj =
      let targetObj = sessionStorage.getItem("targetObj")
      // let targetObj = JSON.stringify(targetObjArr)

      this.$router.push({
        name:'basicMessageSet',
        params:{
          datasetId:this.$route.params.datasetId,
          targetObj:targetObj,
          renderData1:this.renderData1,
          renderData2:this.renderData2,
          renderData3:this.renderData3,
          renderData4:this.renderData4
        }
      })
    },
    reportList(){
      //获取增加页面的最后一个form表单存储的数据
      // sessionStorage.submit = this.sessionStorage.lastform;
      this.$router.push({
        name: 'reportList',
        params: {
          cusId:this.$route.params.cusId
        }
      })
      // alert(cusName)
    },

    //表单隐藏的和展示的功能
    onMouseoverEnvEditBtn(event) {
      event.target.parentElement.querySelector(".env-edit-btn-span").style.cssText += "display:block"
    },
    onMouseleaveEnvEditBtn(event) {
      event.target.parentElement.querySelector(".env-edit-btn-span").style.cssText += "display:none"
    },

    //排序弹框关闭提示
    // handleClose(done) {
    //   // this.$confirm('确认关闭？')
    //   //   .then(_ => {
    //   //     done();
    //   //   })
    //   //   .catch(_ => {});
    // }



  },
}
</script>

<style scoped>
  .df{
    display: flex;
  }
  .fb{
    font-weight: bold;
  }
  .bg{
    background: #f8f8f8;
  }
  .dfac{
    align-items: center;
  }
  .jsb{
    justify-content: space-between;
  }
  .mb20{
    margin-bottom: 10px;
  }
.reportBoxBg{
  background: #FFFFFF;
  box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
  border-radius: 4px;
}
.reportView{
  padding: 10px 20px;
}
.reportViewHeader{
   display: flex;
  justify-content: space-between;
  align-items: center;
 }
.reportViewLeft{
  font-size: 18px;
  color:#333333;
}
.reportViewRight{
  display: flex;
}
.reportViewDatas{
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  border-left:1px solid #ddd;
  border-top:1px solid #ddd;
  background: #e7e7e7;
  overflow-x: auto;
}
.reportViewData{
  flex-shrink:0;
  padding:10px;
  border-right:1px solid #ddd;
  border-bottom:1px solid #ddd;
  color:#000;
  white-space:normal;
  word-break:break-all;
  /*如果需要固定宽度换行，打开注释*/
  /*max-width: 180px;*/
  /*display: flex;*/
  /*align-items: center;*/
}
.reportSelect{
  margin-top: 10px;
}
.reportSelect p{
  margin: 0;
}
.reportSelectLeft{
  /*margin:10px 15px 20px;*/
  text-align: left;
}
.reportSelectLeft .el-input,.reportSelectLeft .el-select{
  width: 100%;
}
.rsForm{
  line-height: 40px;
}
.rsForm p{
  color:#333;
  font-size: 16px;
  text-align:justify;
  width: 80px;
  height: 40px;
  /*font-weight: normal;*/
}
.rsForm p:after{
  content:"";
  padding-left: 100%;
  display: inline-block;
}
.treeBoxs p{
  color:#333;
  font-size: 16px;
  text-align:justify;
  height: 40px;
  line-height: 40px;
  /*font-weight: normal;*/
}
.treeBox{
  height:calc(100vh - 140px - 222px );
}
.leftTree{
  flex:1;
  height: 100%;
  overflow: auto;
  border: 1px solid #efefef;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.rightBtn{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 120px;
  margin-left: 10px;
}
.rightBtn .el-button{
  width: 90px;
  margin: 10px 0;
}
.reportBoxBg.top{
  padding: 10px 10px 0px 10px;
  height: 130px;
}
.reportBoxBg{
  padding: 10px;
}
.reportBoxBg >>> .el-card__header{
  background: #f1f1f1;
  padding: 0 15px;
  line-height: 34px;
}
.reportBoxBg >>> .el-card__header .el-button{
  padding: 0;
  border: none;
  background: transparent;
  font-size: 18px;
}
.treeBtn{
  padding: 0 10px;
  line-height: 20px;
  font-size: 12px;
  color:#fff;
  background: #78ABF8;
  display: none;
}
.reportBoxBg >>>.el-tree-node__content{
  height: 30px;
  padding-right: 5px;
  border-radius: 15px;
}
.reportBoxBg >>>.el-tree-node__content:hover .treeBtn{
  display: block;
}
.custom-tree-node{
  display: flex;
  justify-content: space-between;
  width: calc(100% - 50px);
  align-items: center;
  font-size: 14px;
}
.custom-tree-node span{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.el-card.is-always-shadow{
  box-shadow: none;
}
.reportSelect{
  height:calc(100vh - 140px);
}
.reportSelectRight{
  height:calc(100vh - 140px);
}
  .reportSelectRight .el-row{
    height:100%;
  }
.reportSelectRight .el-col{
  height:calc((100% - 10px) / 2);
}
.reportSelectRight .el-card{
  height: 100%;
}
  .reportSelectRight .el-card >>> .el-card__body{
  height:calc(100% - 34px);
    overflow: auto;
    padding:10px;
}
  .reportSelectLeft .el-tree {
    display: inline-block;

    min-width: 100%;

  }





  .el-dropdown-link {
  cursor: pointer;
  color: #0d0e0e;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}










.dialog-div{
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  line-height: 30px;
  padding:0 10px;
  text-align: left;
}
.dialog-btn{
  display: none;
  flex-shrink: 0;

}
.dialog-div:hover{
  border-radius: 15px;
  background: #efefef;


}
.dialog-div:hover .dialog-btn{
  display: block;



}
.dialog-div .el-button{
  padding: 4px 10px;
  vertical-align: top;
  margin-top: 4px;
}
.dialog-btn .el-input{
  height: 24px;
  width: 50px;
  vertical-align: top;
}
.dialog-btn >>> .el-input__inner{
  height: 24px;
  line-height: 24px;
  padding:0 10px;
}
.dialog-btn input:focus{
  border:1px solid #dcdcdc;
}
/*/deep/ .el-card__header{*/
  /*background-color: #e2e0e0;*/
/*}*/
/*header.el-header{*/
  /*background-color: #eceaea;*/
/*}*/
/*/deep/ .el-dialog__header{*/
  /*background-color: #e2e0e0;*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/reportTools/customQuery.vue